$(() => {

	$('.header-navigation--mobile').on('click', () => {
		$('.header-navigation--nav-left').toggleClass('toggled');
	});

	$('.footer-navigation--widget').on('click', () => {
		window.$zopim && $zopim(() => {
			$zopim.livechat.window.show();
		});
	});

	FileUploadPreview.initialize();
	Collapse.initialize();

});

const FileUploadPreview = {

    initialize: () => {
        $(document).on('change', 'input[type="file"][data-vector-preview]', FileUploadPreview.preview);
        $(document).on('dragover dragexit dragleave drop', '.custom-file', e => {
            if (e.type === 'dragover') {
                e.currentTarget.classList.add('drag-over');
            } else {
                e.currentTarget.classList.remove('drag-over');
            }
        });
    },

    preview: e => {
        const input = e.currentTarget;
        const $preview = $(input.getAttribute('data-vector-preview'));
        const expectedWidth = input.getAttribute('data-vector-expected-width');
        const expectedHeight = input.getAttribute('data-vector-expected-height');

        if (input.files && input.files.length) {
            FileUploadPreview.uploadToTempLocation(input.files[0], input, expectedWidth, expectedHeight).then(path => {
                if (path) {
                    $preview.html(`<img src="${path}" class="img-fluid">`);
                }
                $(input).trigger('upload:preview', path);
            });

        } else {
            $preview.html('');
            $(input).trigger('upload:cancel');
        }
    },

    uploadToTempLocation: (file, input, expectedWidth = null, expectedHeight = null) => {
        return new Promise(resolve => {
            const formData = new FormData();
            formData.append('file', file);

            $.ajax({
                url: `ajax.php?action=uploadFileForPreview&width=${expectedWidth||''}&height=${expectedHeight||''}`,
                data: formData,
                type: 'POST',
                contentType: false,
                processData: false,
                success: response => {
                    if (response.success) {
                        resolve(response.data);
                    } else {
                        message.show('Upload', response.message || 'Error');
                        input.value = '';
                        resolve(false);
                    }
                },
                error: () => resolve(false),
            });

        });
    }

};

const Collapse = {

    initialize: () => {
        $('[data-collapse-control]')
            .off('change', Collapse.changeHandler)
            .on('change', Collapse.changeHandler)
            .triggerHandler('change')
        ;
    },

    changeHandler: e => {
        const $element = $(e.currentTarget);
        const elementId = e.currentTarget.id;
        const elementName = e.currentTarget.name;

        let val = $element.val();

        if ( $element.is('[type=checkbox]') && !$element.is(':checked') ) {
            val = 'NOT_SET';
        }
        else if ( $element.is('[type=radio]') ) {
            val = $(`[name="${elementName}"]:checked`).val() || 'NOT_SET';
        }

        const $targets = $(`[data-collapse-target="#${elementId}"],[data-collapse-target="[name='${elementName}']"]`);

        $targets.each((index, target) => {

            const $target = $(target);
            const values = $target.data('collapse-values') || '';

            let hasMatch = false;
            let i;

            if ( values === '' && !val ) {
                hasMatch = true;
            }

            // Matcher function
            else if ( values.constructor === Object ) {
                let matcher = window;
                const parts = values.matcher.split('.');
                for ( i = 0; i < parts.length; i++ ) {
                    matcher = matcher[parts[i]];
                }
                hasMatch = matcher(val);
            }

            // Value list
            else {
                const valueParts = ('' + values).split(',');
                for ( i = 0; i < valueParts.length; i++ ) {
                    hasMatch = Collapse.checkForMatch(valueParts[i], val);
                    if ( hasMatch ) {
                        break;
                    }
                }
            }

            if ( hasMatch ) {
                $target
                    .addClass('show')
                    .find(':input:not([data-collapse-target] [data-collapse-target] :input,[data-disabled="true"])')
                    .prop('disabled', false)
                ;
                $target.trigger('collapse:show');

                if ($target.find('[type="radio"]').length && !$target.find('[type="radio"]:checked').length) {
                    $target.find('[type="radio"]:first').prop('checked', true).trigger('change');
                }
            } else {
                $target
                    .removeClass('show')
                    .find(':input:not([data-collapse-target] [data-collapse-target] :input)')
                    .prop('disabled', true)
                ;
                $target.trigger('collapse:hide');
            }
        });
    },

    checkForMatch: (subject, value) => {
        if ( subject.substr(0, 1) === '!' ) {
            return subject.substr(1) != value;
        }
        return subject == value;
    }

};
